import { render, staticRenderFns } from "./PhoneMask.vue?vue&type=template&id=70b53a28&"
import script from "./PhoneMask.vue?vue&type=script&lang=ts&"
export * from "./PhoneMask.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneMask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
